
import React, { useRef, useState, memo, useEffect } from 'react'
import { Alert, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { MdLibraryAdd } from 'react-icons/md'
import { emptyGuid } from '../../../utils/emptyGuid.js'
import PositionItem from './PositionItem.jsx'
import ArticleSelectModal from '../../ArticleSelect/ArticleSelectModal.jsx'

const AddPosition = ({ handleAddArticle }) => {
  const { t } = useTranslation()
  const [showAddArticlesModal, setShowAddArticlesModal] = useState(false)
  const [selectedArticles, setSelectedArticles] = useState([])
  const [selectedArticleId, setSelectedArticleId] = useState(emptyGuid)
  useEffect(() => {
    if (!selectedArticles.length) {
      setSelectedArticleId(emptyGuid)
    } else {
      setSelectedArticleId(selectedArticles[0].article.id)
    }
  }, [setSelectedArticleId, selectedArticles])
  return (
    <>
      <Button onClick={() => setShowAddArticlesModal(true)} disabled={false}><MdLibraryAdd className="me-3" />{t('returnsProcessingPage:addPosition')}</Button>
      {showAddArticlesModal
        ? <ArticleSelectModal
          selectedArticles={selectedArticles}
          setSelectedArticles={setSelectedArticles}
          setShowAddArticlesModal={setShowAddArticlesModal}
          showAddArticlesModal={showAddArticlesModal}
          handleSave={() => { setShowAddArticlesModal(false); handleAddArticle(selectedArticleId); setSelectedArticles([]) }}
          singleSelection={true}
          userOffices={true}
        />
        : null}
    </>

  )
}

const PositionList = memo(({ positions, addPosition, copyPosition, splitPosition, setPositions, actionMode, formErrors, resetErrorByFormKey }) => {
  const ref = useRef()

  const isStoring = () => {
    return actionMode === "store";
  }

  const handleDeletePosition = (id) => {
    let index = positions.findIndex(item => item.id === id)
    if (index >= 0) {
      const newPosistions = [...positions]
      newPosistions.splice(index, 1)
      setPositions(newPosistions)
    }
  }
  const handleChangePositionByKey = (id, key, value) => {
    let index = positions.findIndex(item => item.id === id)
    if (index >= 0) {
      const newPosistions = [...positions]
      switch (key) {
        case 'articleVariant':
          newPosistions[index].articleVariant = { id: value }
          break
        default:
          newPosistions[index][key] = value
          break
      }
      setPositions(newPosistions)
    }
  }
  const renderPosition = (position, index) => {
    return (
      <>
        <PositionItem
          key={position.id}
          position={position}
          deletable={!isStoring()}
          handleCopyPosition={copyPosition}
          handleSplitPosition={splitPosition}
          handleDeletePosition={handleDeletePosition}
          handleChangePositionByKey={handleChangePositionByKey}
          isStoring={isStoring()}
          index={index}
          formErrors={formErrors}
          resetErrorByFormKey={resetErrorByFormKey}
        />
      </>
    )
  }
  const { t } = useTranslation()
  return (
    <div ref={ref}>
      <h1>{t('returnsReceiptOverlayProgress:positions')}</h1>
      <div className="spacing-down">
        {positions.length === 0 && (
          <Alert variant="info">{t('returnsProcessingPage:noPositions')}</Alert>
        )}
        {!!formErrors['positions'] && (
          <Alert variant="danger">{formErrors['positions']}</Alert>
        )}
        {positions.map((item, index) => renderPosition(item, index))}
        {!isStoring() && <><div className="mb-1" /><AddPosition handleAddArticle={addPosition} /></>}
      </div>
    </div>
  )
})

export default PositionList
